module.exports = require("./fr-MF.js");